import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MaintenanceMessagesResponse } from '../models/maintenance-messages-response';
import { Observable } from 'rxjs';

@Injectable()
export class MaintenanceMessagesApiService {
  private readonly httpClient = inject(HttpClient);

  private readonly baseUrl = environment.apiUrl + '/maintenance-messages';

  public getMessage(): Observable<MaintenanceMessagesResponse> {
    return this.httpClient.get<MaintenanceMessagesResponse>(this.baseUrl);
  }
}
